import { render, staticRenderFns } from "./AttributeEditor.vue?vue&type=template&id=5799a30e&"
import script from "./AttributeEditor.vue?vue&type=script&lang=js&"
export * from "./AttributeEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5799a30e')) {
      api.createRecord('5799a30e', component.options)
    } else {
      api.reload('5799a30e', component.options)
    }
    module.hot.accept("./AttributeEditor.vue?vue&type=template&id=5799a30e&", function () {
      api.rerender('5799a30e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/AttributeEditor.vue"
export default component.exports